import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class ParallaxImage {
    static instance = null;
    static create(options) {
        if (!ParallaxImage.instance) {
            ParallaxImage.instance = new ParallaxImage(options);
        }
        return ParallaxImage.instance;
    }

    get defaultOptions() {
        return {
            selector : null,
            scroll: null,
        }
    }

    constructor(options) {
        this.options = Object.assign({}, this.defaultOptions, options);
        this.initParallax();
    }

    initParallax() {
        [...this.options.selector].map((element) => {
            const speed = parseFloat(element.getAttribute('data-parallax-speed')) * -100 || '-10%';
            gsap.set(element,{transformOrigin: '50% 50%' });
             gsap.to(element, {
                scrollTrigger: {
                    trigger: element,
                    scrub:  true,
                    start: "top bottom",
                    end: "bottom top",
                },
                y: `${ speed }%`,
            });


        });
    }
}

export default ParallaxImage;
